import { NodeModel, DefaultPortModel, Toolkit } from "storm-react-diagrams";
import * as _ from "lodash";

export class SMSNodeModel extends NodeModel {
    constructor() {
        super("SMS");
        this.name = "";
        this.properties = {
            input: [],
            maxLinks: 1,
            headers: [],
            type: 'multiple',
            name: 'Send an SMS',
            outputData: [],
            message: "SMS Tool",
            columns: {
                
            },
            smsConfigs: {
                vendors: [{name: 'Africas Talking', var_key: 'at'}],
                vendor: 'at',
                
                vendorConfigs: {
                    'at': {
                        bulk: "bulk",
                        // username: "michaelngugin",
                        // apiKey: "e7d0887a58ef17a69cdc8b63e9d474f1a98f97fb64c431eec7d5223f33fc0437",
                        phoneColumn: '',
                        message: '',
                        disableSend: 'true'
                    }
                }
            },
            annotation: "Send an SMS",
            selected_columns: [],
            "datatypes": {
                "float": ["Quantity","Price"],
                "string": []
            },
            messages: [],
            metaData: {}
        }
    }
   
    addOutPort(label) {
        return this.addPort(new DefaultPortModel(false,label, label));
    }
    addInPort(label) {
         
        return this.addPort(new DefaultPortModel(true,label, label));
    }
    printResults(node, port){

        // console.log(node);
        // return node.properties.outputData
        switch(port){
            case 'input':
              return node.properties.input == null ? []: node.properties.input
            case 'output':
              return node.properties.outputData == null ? []: node.properties.outputData
          }
    
      }

    updateName = (e) => {
         this.name = e.target.innerHTML;
         console.log(this.name);
    };

    serialize() {
        return _.merge(super.serialize(), {
            scene_name: this.name
        });
    }
    deSerialize(object, engine) {
        super.deSerialize(object, engine);
        this.name = object.scene_name;
    }
    getInPorts() {
        return _.filter(this.ports, portModel => {
            return portModel.in;
        });
    }

    getOutPorts() {
        return _.filter(this.ports, portModel => {
            return (!portModel.in && !portModel.next);
        });
    }
}
